import React, { useContext, useEffect, useState } from "react";
import { Button, FormControl, Grid, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import AdminTable from "../AdminTable/AdminTable";
import { apisPath, paths } from "../../../utils/path";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import "../../../styles/Layout/Admin_Styles/_AdminSearchDetails.scss";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { authHttp } from "../../services/utility";
import CandidateInfoModal from "../CandidateInfoModal/CandidateInfoModal";
import { AuthContext } from "../../../context/AuthContext";
import { encrypt } from "../../../utils/encryptDecrypt";
import LockResetIcon from "@mui/icons-material/LockReset";
import { useNavigate } from "react-router-dom";
import { fDate } from "../../../utils/formatTime";
import AdminResetPassword from "../AdminResetPassword/AdminResetPassword";
import { appPrefix } from "../../../utils/helpers";

const TableHeadData = [
  {
    id: "application_no",
    label: "Application number",
    link: true,
    type: "link",
    alignItems: 'left'
  },
  { id: "name", label: "Candidate Name", decrypt: true, alignItems: 'left' },
  { id: "posts", label: "Exam Name", isArray: true, alignItems: 'left' },
  { id: "father_name", label: "Father name", decrypt: true, alignItems: 'left' },
  { id: "dob", label: "DOB", date: true, format: "dd/MM/yyyy", alignItems: 'left' },
  // { id: "email", label: "Email ID", decrypt: true, alignItems: 'left' },
  { id: "app_status", label: "Application Status", status: true, alignItems: 'left' },
  { id: "action", label: "", alignItems: 'center', action: true },
];

const defaultSearchValues = {
  email: "",
  name: "",
  father_name: "",
  dob: null,
  submitted_date: null,
  application_status:''
};

const actions = [
  {
    title: 'Reset Password',
    icon: <LockResetIcon className="table-link" />,
    type: 'reset',
    className: 'table-link'
  }
]

const AdminSearchDetails = () => {
  const navigate = useNavigate();
  const { setIsLoading, setAlertState, setIsTableLoading } =
    useContext(AuthContext);
  const [data, setData] = useState([]);
  // const [pageNum, setPageNum] = useState(0);
  const [open, setOpen] = React.useState(false);
  const [actionOpen, setActionOpen] = React.useState({});
  const [selectedId, setSelectedId] = useState("");
  const [paginationData, setPaginationData] = useState({
    currentPage: 0,
    totalRecord: 0,
    rowsPerPage: 10,
  });
  const [searchData, setSearchData] = useState(defaultSearchValues);

  const [finalSearchData, setFinalSearchData] = useState(defaultSearchValues);

  useEffect(() => {
    setIsLoading(true);
    setIsTableLoading(true);
    if (paginationData?.currentPage !== undefined) {
      getData(paginationData?.currentPage + 1, finalSearchData);
    }
  }, []);

  const handleOpen = (id, type) => {
    if (type === "modal") {
      setIsLoading(true);
      setSelectedId(id);
      setOpen(true);
    }
    if (type === "link") {
      navigate(
        `${paths?.admin?.commonPoint}/${paths?.admin?.user?.commonPoint}/${paths?.admin?.user?.candidateInfo}`,
        { state: id }
      );
    }
  };

  const actionHandleClose = (type) => {
    setActionOpen((prev) => (
      {
        ...prev,
        [actionOpen?.selectedModal]: false,
        selectedModal: '',
        id: '',
        name: ''
      }
    ))
  }

  const handleActions = (type, id, name) => {
    setActionOpen((prev) => (
      {
        ...prev,
        [type]: true,
        selectedModal: type,
        id: id,
        name: name
      }
    ))
  }

  const handleClose = () => {
    setOpen(false);
    setSelectedId("");
  };

  const getData = async (page, tempSearch) => {
    authHttp
      .post(apisPath?.admin?.search_by + `?page=${page}`, tempSearch)
      .then((res) => {
        // console.log("search by data:" + res?.data?.data);
        const tempData = res?.data?.data;
        tempData.map((user) => {
          const tempPost = user?.posts.map((post) => {
            return post?.name;
          });
          user.posts = tempPost;
          if (String(user?.application_status) === '2') {
            user.app_status = 'Cancelled'
            user.className = 'fail'
          }
          else {
            if (user?.payment_status === 'Success') {
              user.app_status = 'Completed'
              user.className = 'success'
            }
            else {
              user.app_status = 'In completed'
              user.className = 'proccess'
            }
          }
        });
        setData(tempData);
        setPaginationData((prev) => ({
          ...prev,
          totalRecord: res?.data?.totalusersCount,
          rowsPerPage: res?.data?.resultperpage,
        }));
        setIsLoading(false);
        setIsTableLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        setAlertState((prev) => ({
          ...prev,
          open: true,
          title: err?.response?.data?.msg,
          btnTxt: "CLOSE",
          status: "fail",
          isSessionExpire: err?.response?.status === 401,
          sessionType: "admin",
        }));
      });
  };

  const searchValuesHandler = (key, value) => {
    setSearchData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const searchHandler = () => {
    const tempSearchValue = {
      ...searchData,
      name: searchData?.name
        ? encrypt(searchData?.name.toUpperCase())
        : searchData?.name,
      father_name: searchData?.father_name
        ? encrypt(searchData?.father_name.toUpperCase())
        : searchData?.father_name,
      email: searchData?.email
        ? encrypt(searchData?.email.toLowerCase())
        : searchData?.email,
      mobile: searchData?.mobile
        ? encrypt(searchData?.mobile)
        : searchData?.mobile,
      submitted_date: searchData?.submitted_date ? fDate(searchData?.submitted_date, 'dd/MM/yyyy') : null,
      application_no: searchData?.application_no ? searchData?.application_no.replace(appPrefix, '') : ''
    };
    setPaginationData((prev) => ({
      ...prev,
      currentPage: 0,
    }));
    setIsTableLoading(true);
    getData(1, tempSearchValue);
    setFinalSearchData(tempSearchValue);
  };

  const pageChangeHandler = (page) => {
    setIsTableLoading(true);
    getData(page + 1, finalSearchData);
    setPaginationData((prev) => ({
      ...prev,
      currentPage: page,
    }));
  };

  return (
    <div className="admin-search--details">
      <div className="admin-search--details__header">
        <h2>Candidates</h2>
      </div>
      {/* {JSON.stringify(searchData)} */}
      <div className="admin-search--details__card">

        <Grid container spacing={3} alignItems="center">
          <Grid item lg={3} md={3} sm={6} xs={12}>
            <div className="admin-search--details__textfield">
              <TextField
                fullWidth
                autoComplete="off"
                id="outlined-basic"
                label="Search by Email ID/Mobile No."
                variant="outlined"
                onChange={(e) => {
                  if (Number(e.target.value)) {
                    searchValuesHandler("email", '');
                    searchValuesHandler("mobile", e.target.value);
                  }
                  else {
                    searchValuesHandler("mobile", '');
                    searchValuesHandler("email", e.target.value);
                  }
                }}
              />
            </div>
          </Grid>
          <Grid item lg={3} md={3} sm={6} xs={12}>
            <div className="admin-search--details__textfield">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  autoComplete="off"
                  fullWidth
                  views={["year", "month", "day"]}
                  label="Submitted Date"
                  inputFormat="DD/MM/YYYY"
                  name="submitted_date"
                  value={searchData?.submitted_date}
                  onChange={(e) => {
                    searchValuesHandler("submitted_date", e);
                  }}
                  renderInput={(params) => (
                    <TextField
                      autoComplete="off"
                      fullWidth
                      {...params}
                      onDrop={(e) => {
                        e.preventDefault();
                        return false;
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </div>
          </Grid>
          <Grid item lg={3} md={3} sm={6} xs={12}>
            <div className="admin-search--details__textfield">
              <TextField
                fullWidth
                autoComplete="off"
                id="outlined-basic"
                label="Search by Name"
                variant="outlined"
                onChange={(e) => {
                  searchValuesHandler("name", e.target.value);
                }}
              />
            </div>
          </Grid>
          <Grid item lg={3} md={3} sm={6} xs={12}>
            <div className="admin-search--details__textfield">
              <TextField
                fullWidth
                autoComplete="off"
                id="outlined-basic"
                label="Search by Father Name"
                variant="outlined"
                onChange={(e) => {
                  searchValuesHandler("father_name", e.target.value);
                }}
              />
            </div>
          </Grid>
          <Grid item lg={3} md={3} sm={6} xs={12}>
            <div className="admin-search--details__textfield">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  autoComplete="off"
                  fullWidth
                  views={["year", "month", "day"]}
                  label="DOB"
                  inputFormat="DD/MM/YYYY"
                  name="dob"
                  value={searchData?.dob}
                  onChange={(e) => {
                    searchValuesHandler("dob", e);
                  }}
                  renderInput={(params) => (
                    <TextField
                      autoComplete="off"
                      fullWidth
                      {...params}
                      onDrop={(e) => {
                        e.preventDefault();
                        return false;
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </div>
          </Grid>
          <Grid item lg={3} md={3} sm={6} xs={12}>
            <div className="admin-search--details__textfield">
              <TextField
                fullWidth
                autoComplete="off"
                id="outlined-basic"
                label="Search by Application No."
                variant="outlined"
                onChange={(e) => {
                  searchValuesHandler("application_no", e.target.value);
                }}
              />
            </div>
          </Grid>
          <Grid item lg={3} md={3} sm={6} xs={12}>
            <div className="admin-search--details__textfield">
              <FormControl fullWidth>
                <InputLabel id="application_status-label">
                  Application Status
                </InputLabel>
                <Select
                  fullWidth
                  autoComplete="off"
                  labelId="application_status-label"
                  id="application_status"
                  label="Application Status"
                  name="application_status"
                  value={searchData?.application_status}
                  onChange={(e) => {
                    searchValuesHandler("application_status", e.target.value);
                  }}
                >
                  <MenuItem value={""}>Select</MenuItem>
                  <MenuItem value={"completed"}>Completed</MenuItem>
                  <MenuItem value={"in_completed"}>In completed</MenuItem>
                  <MenuItem value={"cancelled"}>Cancelled</MenuItem>
                </Select>
              </FormControl>
            </div>
          </Grid>
          <Grid item lg={1.5} md={1.5} sm={6} xs={12}>
            <div className="admin-search--details__button">
              <Button variant="contained" onClick={searchHandler}>
                Search
              </Button>
            </div>
          </Grid>
        </Grid>
        <div className="admin-search--details__table">
          <AdminTable
            tableHead={TableHeadData}
            pageChangeHandler={pageChangeHandler}
            data={data}
            paginationData={paginationData}
            handleOpen={handleOpen}
            actions={actions}
            handleActions={handleActions}
          />
        </div>
      </div>
      {open && (
        <CandidateInfoModal
          open={open}
          handleClose={handleClose}
          selectedId={selectedId}
        />
      )}
      {actionOpen[actionOpen?.selectedModal] &&
        <AdminResetPassword
          open={actionOpen[actionOpen?.selectedModal]}
          actionData={actionOpen}
          resetHandleClose={actionHandleClose}
        />
      }
    </div>
  );
};

export default AdminSearchDetails;
